import { EStationSetupStep } from '@/config/station';

import type { TStep } from '@/components/stepper/types';

import type { TCreateStationForm } from '@/types/station';

import { BankConnection } from './BankConnection';
import { Completion } from './Completion';
import { GeneralInformation } from './GeneralInformation';
import { StationAmenities } from './StationAmenities';
import { StationType } from './StationType';
import { SystemConnection } from './SystemConnection';

export const STATION_SETUP_STEPS: TStep<EStationSetupStep, TCreateStationForm>[] = [
  {
    id: EStationSetupStep.STATION_TYPE,
    title: 'stationSetup.stationType.stepperItem',
    Component: StationType,
  },
  {
    id: EStationSetupStep.GENERAL_INFORMATION,
    title: 'stationSetup.generalInfo.title',
    Component: GeneralInformation,
  },
  {
    id: EStationSetupStep.STATION_AMENITIES,
    title: 'stationSetup.stationAmenities.title',
    Component: StationAmenities,
  },
  {
    id: EStationSetupStep.CONNECT_BANK,
    title: 'stationSetup.connectBank.title',
    Component: BankConnection,
  },

  {
    id: EStationSetupStep.CONNECT_SYSTEM,
    title: 'stationSetup.connectSystem.stepperItem',
    Component: SystemConnection,
  },
  {
    id: EStationSetupStep.COMPLETE,
    title: 'stationSetup.complete.stepperItem',
    Component: Completion,
  },
];
